import ProductCard from "./ProductCard";
import React from "react";

export default function AllProductProduktif(){
    return(
        <div className='container-alur'>
            <h2 className='text-header'>Produk Pinjaman Produktif</h2>
            <div className='all-product'>
                <ProductCard
                    type='produktif'
                    product='invoice-financing'
                    title='<em>Invoice Financing</em>'
                    description='Fasilitas pinjaman yang diberikan kepada Pelaku Usaha yang memerlukan pembiayaan pada saat menunggu proses pembayaran dari Pemberi Kerja <em>(Bowheer)</em> dan/atau Pembeli <em>(Buyer)</em> dengan menggunakan jaminan <em>invoice.</em>' />
                <ProductCard
                    type='produktif'
                    product='inventory-financing'
                    title='<em>Inventory Financing</em>'
                    description='Fasilitas pinjaman yang diberikan kepada Pelaku Usaha dengan menggunakan barang persediaan sebagai jaminan.'
                />
                {/*<ProductCard*/}
                {/*    type='produktif'*/}
                {/*    product='investment-financing'*/}
                {/*    title='<em>Investment Financing</em>'*/}
                {/*    description='Fasilitas pinjaman yang diberikan kepada Pelaku Usaha dimana penggunaannya diperuntukkan sebagai pembelian barang untuk investasi.'*/}
                {/*/>*/}
                <ProductCard
                    type='produktif'
                    product='developer-financing'
                    title='<em>Developer Financing</em>'
                    description='Fasilitas pinjaman yang diberikan kepada Pelaku Usaha (Developer) dimana penggunaannya diperuntukkan sebagai modal pembangunan perumahan dengan skema pembayaran yang fleksibel.'
                />
            </div>
        </div>
    );
}